import{Logger as e}from"../../utils/logger.js";function o(o,n){window.Moengage?window.Moengage.track_event(o,n):e.error("Moengage not loaded")}export{o as default};
